export const ACTION_FORGOT_PASSWORD = "ACTION_FORGOT_PASSWORD";
export const ACTION_CONFIRM_FORGOT_PASSWORD = "ACTION_CONFIRM_FORGOT_PASSWORD";
export const ACTION_FETCH_USER_LOGIN = "ACTION_FETCH_USER_LOGIN";
export const ACTION_DO_LOGOUT = "ACTION_DO_LOGOUT";
export const ACTION_UPDATE_USER_INFORMATION = "ACTION_UPDATE_USER_INFORMATION";
export const ACTION_CHANGE_USER_PASSWORD = "ACTION_CHANGE_USER_PASSWORD";
export const ACTION_ADD_USER = "ACTION_ADD_USER";
export const ACTION_GET_USER_LIST = "ACTION_GET_USER_LIST";
export const ACTION_GET_USER_DETAIL = "ACTION_GET_USER_DETAIL";
export const ACTION_GET_USER_TANGO_BALANCE = "ACTION_GET_USER_TANGO_BALANCE";
export const ACTION_EDIT_USER = "ACTION_EDIT_USER";
export const ACTION_SET_USER_BLOCKING = "ACTION_SET_USER_BLOCKING";
export const ACTION_SET_REINVITE_USER = "ACTION_SET_REINVITE_USER";
export const ACTION_GET_USER_LOGIN_INFO = "ACTION_GET_USER_LOGIN_INFO";
export const ACTION_VERIFY_INVITATION_TOKEN = "ACTION_VERIFY_INVITATION_TOKEN";
export const ACTION_COGNITO_CONFIRM_PASSWORD =
  "ACTION_COGNITO_CONFIRM_PASSWORD";
export const ACTION_CONFIRM_CHALLENGE = "ACTION_CONFIRM_CHALLENGE";
export const ACTION_SET_EMPTY_MFA_DATA = "ACTION_SET_EMPTY_MFA_DATA";
export const ACTION_SET_TEMP_USER_INFO = "ACTION_SET_TEMP_USER_INFO";
export const ACTION_SET_MFA_METHOD = "ACTION_SET_MFA_METHOD";
export const ACTION_GET_ACTIVITIES_LOG_ENTITIES =
  "ACTION_GET_ACTIVITIES_LOG_ENTITIES";
export const ACTION_GET_ACTIVITIES_LOG = "ACTION_GET_ACTIVITIES_LOG";

export const COMMIT_SET_USER_LOGIN = "COMMIT_SET_USER_LOGIN";
export const SET_FROM_LOGIN = "SET_FROM_LOGIN";

export const MUTATION_DO_LOGOUT = "MUTATION_DO_LOGOUT";
export const MUTATION_SET_USER_LIST = "MUTATION_SET_USER_LIST";
export const MUTATION_BLOCK_USER = "MUTATION_BLOCK_USER";
export const MUTATION_SET_MFA_DATA = "MUTATION_SET_MFA_DATA";
export const MUTATION_SET_TEMP_USER_INFO = "MUTATION_SET_TEMP_USER_INFO";
export const MUTATION_SET_ACTIVITIES_LOG_ENTITIES =
  "MUTATION_SET_ACTIVITIES_LOG_ENTITIES";
export const MUTATION_SET_ACTIVITIES_LOG = "MUTATION_SET_ACTIVITIES_LOG";
export const MUTATION_SET_MFA_FE = "MUTATION_SET_MFA_FE";

export const GETTER_IS_LOGGEDIN = "GETTER_IS_LOGGEDIN";
export const GETTER_USER_INFO = "GETTER_USER_INFO";
export const GETTER_FROM_LOGIN_DETECT = "GETTER_FROM_LOGIN_DETECT";
export const GETTERS_CLIENT_SERVICES_CONFIGURATION =
  "GETTERS_CLIENT_SERVICES_CONFIGURATION";
export const GETTER_LIST_USER = "GETTER_LIST_USER";
export const GETTER_USER_PAGINATION = "GETTER_USER_PAGINATION";
export const GETTER_MFA_DATA = "GETTER_MFA_DATA";
export const GETTER_TEMP_USER_INFO = "GETTER_TEMP_USER_INFO";
export const GETTER_ACTIVITIES_LOG_ENTITIES = "GETTER_ACTIVITIES_LOG_ENTITIES";
export const GETTER_ACTIVITIES_LOG = "GETTER_ACTIVITIES_LOG";
export const GETTER_ACTIVITIES_LOG_PAGINATION =
  "GETTERS_ACTIVITIES_LOG_PAGINATION";



// WEBPACK FOOTER //
// ./src/store/modules/users/constants.js